export default {
  header: 'Proyectos',
  navLink: '/app/projects',
  children: []
}
